{
  "Billing": "Facturación",
  "Return to App": "Volver a la aplicación",
  "Home": "Inicio",
  "Calendar": "Calendario",
  "Dashboard": "Panel",
  "ATP": "ATP",
  "Subscriptions": "Suscripciones",
  "Payment Methods": "Métodos de pago",
  "Purchases": "Compras",
  "View Profile": "Ver perfil",
  "TrainingPeaks Athlete Since": "Atleta de TrainingPeaks desde",
  "TrainingPeaks Coach Since": "Entrenador de TrainingPeaks desde",
  "Invoice": "Factura",
  "No results": "No hay resultados",
  "qtr": "trim.",
  "Show all transactions": "Mostrar todas las transacciones",
  "No transactions found": "No se han encontrado transacciones",
  "Loading purchases": "Cargando compras",
  "Error loading purchases": "Error al cargar las compras",
  "Active": "Activa",
  "Inactive": "Inactiva",
  "Cancelled": "Cancelada",
  "PastDue": "Vencida",
  "Trialing": "En prueba",
  "Next Renewal": "Próxima renovación",
  "Manage": "Gestionar",
  "plus tax": "más impuestos",
  "No subscriptions found": "No se han encontrado suscripciones",
  "No purchases found": "No se han encontrado compras",
  "Show all": "Mostrar todo",
  "Show less": "Mostrar menos",
  "Date": "Fecha",
  "Description": "Descripción",
  "Amount": "Importe",
  "Status": "Estado",
  "Paid": "Pagada",
  "Failed": "Fallida",
  "Pending": "Pendiente",
  "Refunded": "Reembolsada",
  "Loading": "Cargando",
  "Error loading data": "Error al cargar los datos",
  "month": "mes",
  "year": "año",
  "quarter": "trimestre",
  "mo": "mes",
  "yr": "año",
  "Default": "Predeterminado",
  "Expires": "Caduca",
  "Card ending in": "Tarjeta terminada en",
  "Flexible planning to fit your life": "Planificación flexible que se adapta a tu vida",
  "Actionable Insights to keep you on track": "Información práctica para mantenerte en el camino",
  "Strength training to avoid injury": "Entrenamiento de fuerza para evitar lesiones",
  "Ride the world inside on Virtual": "Recorre el mundo desde dentro con Virtual",
  "Any sport, any device, any time": "Cualquier deporte, cualquier dispositivo, en cualquier momento",
  "Annual": "Anual",
  "Monthly": "Mensual",
  "Billed USD $134.99/yr": "Facturado: 134,99 USD/año",
  "Most Popular": "Más popular",
  "$19.95 $11.25/mo": "19,95 $ 11,25 $/mes",
  "$19.95/mo": "19,95 $/mes",
  "Checkout": "Pagar",
  "Progress starts with Premium.": "El progreso empieza con Premium.",
  "Add Card": "Añadir tarjeta",
  "Close": "Cerrar",
  "Primary": "Principal",
  "Delete": "Eliminar",
  "Make Primary": "Establecer como principal",
  "Error loading payment methods": "Error al cargar los métodos de pago",
  "Your card has expired. Please add a new card.": "Tu tarjeta ha caducado. Añade una tarjeta nueva.",
  "Unable to load payment form. Please try again later.": "No se ha podido cargar el formulario de pago. Inténtalo de nuevo más tarde.",
  "A temporary $1.00 charge will be made to validate your payment method. This charge is automatically refunded.": "Se realizará un cargo temporal de 1,00 $ para validar tu método de pago. Este cargo se reembolsa automáticamente.",
  "Payment method added successfully": "Método de pago añadido correctamente",
  "Default payment method updated": "Método de pago predeterminado actualizado",
  "Payment method deleted": "Método de pago eliminado",
  "Failed to set default payment method": "No se ha podido establecer el método de pago predeterminado",
  "Failed to update default payment method": "No se ha podido actualizar el método de pago predeterminado",
  "Failed to delete payment method": "No se ha podido eliminar el método de pago",
  "Maximize Your Premium Subscription \n Before You Go!": "Aprovecha al máximo tu suscripción Premium\nantes de irte",
  "TrainingPeaks Virtual": "TrainingPeaks Virtual",
  "Ride inside with our virtual cycling experience": "Pedalea en interior con nuestra experiencia de ciclismo virtual",
  "Strength Builder": "Creador de fuerza",
  "Create and save strength workouts": "Crea y guarda entrenamientos de fuerza",
  "Metrics Charts": "Gráficos de métricas",
  "Analyze metrics from your synced devices": "Analiza métricas de tus dispositivos sincronizados",
  "Performance Metrics": "Métricas de rendimiento",
  "Fitness (CTL), Fatigue (ATL) and Form (TSB)": "Estado físico (CTL), fatiga (ATL) y forma (TSB)",
  "Peak Performances": "Mejores rendimientos",
  "Track and compare your best efforts": "Sigue y compara tus mejores esfuerzos",
  "NEW!": "¡NUEVO!",
  "Cancel Subscription": "Cancelar suscripción",
  "Renew Subscription": "Renovar suscripción",
  "Complimentary": "De cortesía",
  "Your complimentary access is active through": "Tu acceso de cortesía está activo hasta",
  "Keep your goals in sight -- renew Premium to stay on track for race day.": "Mantén tus objetivos a la vista: renueva Premium para seguir en el buen camino hasta el día de la carrera.",
  "Renew": "Renovar",
  "Auto-Renew Off": "Renovación automática desactivada",
  "Access through": "Acceso hasta",
  "Turn Auto-Renew On": "Activar renovación automática",
  "Are you sure you want to cancel coaching?": "¿Seguro que quieres cancelar el coaching?",
  "Reaching your goals takes the right fit. Before you cancel, let us know if you need to pause, adjust your package level, or speak directly with a Coach Match Specialist.": "Alcanzar tus objetivos requiere el acompañamiento adecuado. Antes de cancelar, dinos si necesitas pausar, ajustar el nivel de tu paquete o hablar directamente con un especialista de Coach Match.",
  "Pause, Adjust, or Contact Support": "Pausar, ajustar o contactar con soporte",
  "Yes, Cancel": "Sí, cancelar",
  "Keep My Coaching": "Mantener mi coaching",
  "Coach Match subscription: Pause, Adjust, or Speak with Specialist": "Suscripción Coach Match: Pausar, ajustar o hablar con un especialista",
  "Hi Coach Match Team,\n\nI am reaching out regarding my coaching membership. Before deciding whether to cancel, I would like to [pause my membership / adjust my package level / speak with a Coach Match Specialist].\n\nMy account email is: [Your Email]\n\nThanks!": "Hola equipo de Coach Match,\n\nMe pongo en contacto con vosotros respecto a mi membresía de coaching. Antes de decidir si cancelar, me gustaría [pausar mi membresía / ajustar el nivel de mi paquete / hablar con un especialista de Coach Match].\n\nMi correo electrónico de cuenta es: [Tu correo electrónico]\n\n¡Gracias!",
  "Before you go...": "Antes de irte...",
  "What's the reason for canceling?": "¿Cuál es el motivo de la cancelación?",
  "Price / Financial Reasons": "Precio / Motivos económicos",
  "The subscription cost no longer fits my budget.": "El coste de la suscripción ya no se ajusta a mi presupuesto.",
  "Injured / Health Reasons": "Lesión / Motivos de salud",
  "I'm unable to train due to injury or health.": "No puedo entrenar debido a una lesión o motivos de salud.",
  "Finished Goal Event": "Evento objetivo completado",
  "I completed my target race or event.": "He completado mi carrera o evento objetivo.",
  "Poor Experience / Fit": "Mala experiencia / No era lo adecuado",
  "The coaching style or program wasn't the right match.": "El estilo de coaching o el programa no eran los adecuados.",
  "Temporary Pause / Restart Later": "Pausa temporal / Reanudar más tarde",
  "Life got busy — I'd like to come back when I'm ready.": "La vida se complicó — me gustaría volver cuando esté listo.",
  "Other": "Otro",
  "Optional: Why?": "Opcional: ¿Por qué?",
  "Continue": "Continuar",
  "Keep Subscription": "Mantener suscripción"
}
